export default __webpack_public_path__ + "static/media/udemy.21967d44.webp";